import React from "react";
import { SESSION_MINUTES, SESSION_PRICE } from "../../../data/mentorshipData";
import { Avatar, Badge, VerifiedIcon } from "./MentorParts";

const MentorCard = ({ mentor, onOpen }) => (
  <button
    type="button"
    className="ms-card ms-mentor-card"
    onClick={() => onOpen(mentor.id)}
  >
    <div className="ms-mrow">
      <Avatar mentor={mentor} size={48} />
      <div className="ms-grow">
        <div className="ms-name">
          {mentor.name} {mentor.verified && <VerifiedIcon />}
        </div>
        <div className="ms-cred">{mentor.cred}</div>
        <div className="ms-tag">{mentor.tag}</div>
      </div>
    </div>
    <div className="ms-mfoot">
      <div className="ms-badges">
        {mentor.cats.slice(0, 2).map((cat) => (
          <Badge key={cat} tone="brand">
            {cat}
          </Badge>
        ))}
        {mentor.badges.map(([tone, label]) => (
          <Badge key={label} tone={tone}>
            {label}
          </Badge>
        ))}
      </div>
      <div className="ms-price">
        ${SESSION_PRICE} <small>/ {SESSION_MINUTES} min</small>
      </div>
    </div>
  </button>
);

export default MentorCard;
